import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container, Logo } from '../../design';
import { AUDIENCE_PAGES, AUDIENCES, CONTACT_EMAIL, MKT, PRODUCTS } from './links';
const SITE = [
    [
        'Home',
        MKT.home
    ],
    [
        'Importing guide',
        MKT.guide
    ],
    [
        'Blog',
        MKT.blog
    ],
    [
        'Pricing',
        MKT.pricing
    ],
    [
        'FAQ',
        MKT.faq
    ],
    [
        'Security & privacy',
        MKT.security
    ],
    [
        'Terms of Service',
        MKT.terms
    ],
    [
        'Get started',
        MKT.signup
    ],
    [
        'Talk to us first',
        MKT.requestAccess
    ],
    [
        'Sign in',
        MKT.login
    ]
];
export function Footer() {
    return /*#__PURE__*/ _jsxs("footer", {
        className: "mk-footer rhd-band-ai",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "rhd-seigaiha-strip"
            }),
            /*#__PURE__*/ _jsxs(Container, {
                className: "mk-footer__grid",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mk-footer__brand",
                        children: [
                            /*#__PURE__*/ _jsx(Logo, {
                                href: MKT.home,
                                size: "footer",
                                onDark: true
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "mk-footer__about",
                                children: "Software for bringing Japanese-market vehicles home from auction. It’s for dealerships sourcing cars for customers and stock, and for people importing a car of their own."
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-footer__contact",
                                children: [
                                    "righthanddms.com",
                                    /*#__PURE__*/ _jsx("br", {}),
                                    CONTACT_EMAIL
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mk-footer__col",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "mk-footer__head",
                                children: "対象 · Who it’s for"
                            }),
                            AUDIENCES.map((a)=>/*#__PURE__*/ _jsx("a", {
                                    href: MKT.audience(a),
                                    children: AUDIENCE_PAGES[a].name
                                }, a)),
                            /*#__PURE__*/ _jsx("a", {
                                href: MKT.pricingFor('dealer'),
                                children: "Dealership plans"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: MKT.dealerWebsites,
                                children: "Dealer websites"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: MKT.pricingFor('individual'),
                                children: "Import my own pricing"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mk-footer__col",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "mk-footer__head",
                                children: "製品 · Product"
                            }),
                            PRODUCTS.map((p)=>/*#__PURE__*/ _jsx("a", {
                                    href: MKT.product(p.slug),
                                    children: p.name
                                }, p.slug))
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mk-footer__col",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "mk-footer__head",
                                children: "案内 · Site"
                            }),
                            SITE.map(([label, href])=>/*#__PURE__*/ _jsx("a", {
                                    href: href,
                                    children: label
                                }, href))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Container, {
                className: "mk-footer__base",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        children: "© 2026 Right Hand DMS"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: "US imports under the 25-year rule"
                    })
                ]
            })
        ]
    });
}
